import axios from 'axios';
import * as apiURL from './apiConfig';

export const getFaq = async () => {
  try {
    const response = await axios.get(apiURL.FAQ_URL);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getTestimonials = async () => {
  try {
    const response = await axios.get(apiURL.TESTIMONIAL_URL);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
